export const REVISION = "5.7.17";
/**
 * @method GetVersion
 * @for mm
 */
export function GetVersion() {
    return REVISION;
}
/**
 * Open Debug Window
 * Under Firefox, add "<File>" to the list of allowed sites if you want to debug locally
 * @method Debug
 * @for mm
 */
export function Debug() {
    return;
}
/**
 * Warning log message.
 * @method Warning
 * @for mm
 * @param {string} text
 */
export function Warning(text) {
    console.log(text);
}
/**
 * Warning log message.
 * @method Error
 * @for mm
 * @param {string} text
 */
export function Error(text) {
    console.log(text);
}
/**
 * Log message.
 * @method Log
 * @for mm
 * @param {string} text
 */
export function Log(text) {
    console.log(text);
}
//# sourceMappingURL=mm.js.map